import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GrEdit } from "react-icons/gr";
import { FaPlus, FaRegEdit } from "react-icons/fa";
import {
  useAddFoodItemCountMutation,
  useGetMyOutletFoodItemsQuery,
} from "../slices/FoodItemSilce";
import { Button, Col, Form, Row } from "react-bootstrap";
import { cardStyle, labelStyle } from "../components/OutletFormKit";

import { useLocation, useNavigate } from "react-router-dom";
import ReUsableModal from "../components/ReUsableModal";
import { toast } from "react-toastify";
import LazyMemberImage from "../components/LazyMemberImage";
import { CgPlayStopR } from "react-icons/cg";
import { setCredentials } from "../slices/authSlice";
import EditFoodItemDetails from "./EditFoodItemDetails";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { formatAmount, makeFirstCharCapital } from "../utils/commonUtils";

const DetailRow = ({ label, children }) => (
  <div
    className="d-flex justify-content-between align-items-center flex-wrap"
    style={{
      padding: "0.5rem 0",
      borderBottom: "1px solid #f1f6fa",
      gap: "0.5rem",
    }}
  >
    <span style={{ fontSize: "0.8rem", fontWeight: "600", color: "#6c757d" }}>
      {label}
    </span>
    <span
      style={{
        fontSize: "0.88rem",
        fontWeight: "600",
        color: "#344a5e",
        textAlign: "right",
      }}
    >
      {children}
    </span>
  </div>
);

const YesNoChip = ({ value }) => (
  <span
    style={{
      padding: "0.1rem 0.6rem",
      borderRadius: "999px",
      fontSize: "0.75rem",
      fontWeight: "600",
      backgroundColor: value ? "#e8f6ee" : "#fdecec",
      border: `1px solid ${value ? "#b7e0c6" : "#f5c2c7"}`,
      color: value ? "#1e7e34" : "#c0392b",
    }}
  >
    {value ? "Yes" : "No"}
  </span>
);

const sizeBoxStyle = {
  border: "1px solid #e3ecf3",
  borderRadius: "10px",
  padding: "0.6rem 0.75rem",
  marginBottom: "0.5rem",
  backgroundColor: "#f9fcfe",
};

const AllFoodItemsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const { state } = useLocation();
  const { foodItem } = state || {};
  console.log("foodItem");
  console.log(foodItem);
  const [itemName, setItemName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [addQuantity, setAddQuantity] = useState("");
  const [newQuantity, setNewQuantity] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [showItemCountModal, setShowItemCountModal] = useState(false);
  const [searchFood, setSearchFood] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [itemQuantities, setItemQuantities] = useState({});
  const quantityRef = useRef(null);
  const [selectedItemDetails, setSelectedItemDetails] = useState(
    foodItem || ""
  );
  const [editable, setEditable] = useState(false);

  // The edit form copies the item's values into its own state when it
  // opens, so selecting a different item must close it; otherwise it keeps
  // showing (and would save) the previously selected item
  useEffect(() => {
    setEditable(false);
  }, [selectedItemDetails?._id]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("editable");
  console.log(editable);
  const {
    data: foodItems,
    isLoading,
    refetch,
    error,
  } = useGetMyOutletFoodItemsQuery({ token: userInfo.token });

  const [addFoodItemCount, { isLoading: addingCount }] =
    useAddFoodItemCountMutation();

  const filteredFoods = foodItems?.filter((item) =>
    item.itemName.toLowerCase().includes(searchFood.toLowerCase())
  );

  useEffect(() => {
    if (!isLoading && !error) {
      refetch();
    }
  }, [isLoading, error, refetch]);

  useEffect(() => {
    if (foodItems && foodItems.length > 0) {
      const categories = getCategories();
      if (categories.length > 0) {
        setSelectedCategory(categories[0]);
      }
    }
  }, [foodItems]);

  useEffect(() => {
    if (!isLoading && foodItems) {
      dispatch(setCredentials({ ...userInfo, AllFoods: foodItems }));
    }
  }, [isLoading, foodItems]);

  useEffect(() => {
    if (quantity != null && addQuantity != null) {
      setNewQuantity(Number(quantity) + Number(addQuantity));
    }
  }, [quantity, addQuantity]);

  useEffect(() => {
    if (selectedCategory && foodItems?.length > 0) {
      const items = getItemsByCategory(selectedCategory);

      if (items && items.length > 0) {
        setSelectedItemDetails(items[0]);
      }
    }
  }, [selectedCategory, foodItems]);

  const addItemHandler = (item) => {
    setItemName(item?.itemName);
    setQuantity(item?.itemQuantity);
    setNewQuantity(item?.itemQuantity);
    setSelectedItemId(item._id);
    setShowItemCountModal(true);
  };

  const submitAddFoodItem = async () => {
    try {
      const data = {
        _id: selectedItemId,
        itemCount: addQuantity,
        token: userInfo.token,
      };

      const resData = await addFoodItemCount(data).unwrap();
      setSelectedItemDetails(resData);
      await refetch();
      setShowItemCountModal(false);
      toast.success(" Item quantity updated Successfully");
    } catch (err) {
      console.error("Error adding food count : ", err);
    }
  };

  const handleCancelEdit = () => {
    setAddQuantity("");
    setNewQuantity("");
    setShowItemCountModal(false);
  };

  // Extract unique category names
  const getCategories = () => {
    if (!foodItems) return [];
    const categorySet = new Set();
    foodItems.forEach((item) => {
      if (item.itemCategory) categorySet.add(item.itemCategory);
    });
    return Array.from(categorySet).sort((a, b) => a.localeCompare(b));
  };

  // Get items belonging to selected category

  const getItemsByCategory = (category) => {
    if (searchFood?.length > 0)
      return filteredFoods.sort((a, b) =>
        (a.itemName || "").localeCompare(b.itemName || "")
      );
    else
      return foodItems
        ?.filter((item) => item.itemCategory === category)
        .sort((a, b) => (a.itemName || "").localeCompare(b.itemName || ""));
  };

  // const handleEditStatus = () => {
  //   navigate(`/editFoodItem/${selectedItemDetails._id}`, {
  //     state: { foodItem: selectedItemDetails },
  //   });

  // };

  const handleEditStatus = () => {
    refetch();
    setEditable(false);
  };

  return (
    <>
      <ReUsableModal
        title="Add Food Count"
        payload={[
          {
            fieldName: "Item Name",
            fieldType: "text",
            fieldValue: itemName,
            setMethod: setItemName,
            disabled: true,
          },
          {
            fieldName: "Existing Quantity",
            fieldType: "number",
            fieldValue: quantity,
            setMethod: setQuantity,
            disabled: true,
          },
          {
            fieldName: "Add Quantity",
            fieldType: "number",
            fieldValue: addQuantity,
            setMethod: setAddQuantity,
          },
          {
            fieldName: "New Quantity",
            fieldType: "number",
            fieldValue: newQuantity,
            setMethod: setNewQuantity,
            disabled: true,
          },
        ]}
        show={showItemCountModal}
        size="md"
        onHide={() => handleCancelEdit(false)}
        onSubmit={submitAddFoodItem}
        submit="Submit"
        cancel="Cancel"
      />
      <div
        className="d-flex flex-wrap justify-content-center align-items-center"
        style={{ gap: "0.6rem", padding: "0.25rem 0.5rem 0.6rem" }}
      >
        <Form.Control
          type="text"
          placeholder="Search food items"
          value={searchFood}
          onChange={(e) => {
            const val = e.target.value.replace(/[0-9]/g, "");
            setSearchFood(val);
          }}
          style={{ flex: "1 1 220px", maxWidth: "360px" }}
        />
        <Button
          className={`${userInfo?.themeColor}ThemeHeaderTop`}
          style={{
            fontWeight: "600",
            borderRadius: "8px",
            whiteSpace: "nowrap",
          }}
          onClick={() => navigate("/createFoodItems")}
        >
          <FaPlus style={{ marginBottom: "2px" }} /> Create Food Item
        </Button>

        {/* <Col>
          {searchFood?.length > 0 && (
            <h6 style={{ color :  "red" }}>You are seeing searched food items</h6>
          )}
          {isLoading ? (
            <Loader />
          )  :  error ? (
            <Message>
              {error?.data?.error || "Error fetching food items"}
            </Message>
          )  :  (
            <Table
              striped
              bordered
              hover
              responsive="sm"
              className="table-custom"
            >
              <thead className={`${userInfo.themeColor}ThemeThead`}>
                <tr>
                  <th></th>
                  <th>Item Name</th>
                  <th>Item Code</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                {filteredFoods?.length > 0 ? (
                  filteredFoods.map((item) => (
                    <tr key={item._id}>
                      <td>
                        <td>
                          <LazyMemberImage
                            foodItemId={item._id}
                            imageUpdatedTimeFromDB={item.imageUploadedTime}
                            currentlySelling={item.currentlySelling}
                            photoUploaded={item.imageUploaded}
                          />
                        </td>
                      </td>
                      <td>
                        <a
                          onClick={() =>
                            navigate(`/foodItem/${item._id}`, {
                              state :  { from :  "allFoodItems", showEdit :  true },
                            })
                          }
                          style={{
                            cursor :  "pointer",
                            textDecoration :  "underline",
                          }}
                        >
                          {item?.itemName}
                        </a>{" "}
                        {item.isVeg ? (
                          <CgPlayStopR
                            style={{ color :  "green", width :  "0.7rem" }}
                          />
                        )  :  (
                          <CgPlayStopR
                            style={{ color :  "red", width :  "0.7rem" }}
                          />
                        )}
                      </td>
                      <td>{item?.itemCode}</td>
                      <td>
                        <span
                          style={{
                            color :  item.itemQuantity < 10 && "red",
                            fontSize :  "1.1rem",
                            marginRight :  "0.5rem",
                          }}
                        >
                          {item.itemQuantity}
                        </span>
                        <GrEdit
                          style={{ cursor :  "pointer" }}
                          onClick={() => addItemHandler(item)}
                        />
                      </td>
                    </tr>
                  ))
                )  :  (
                  <tr>
                    <td colSpan={4}>
                      <Message>No food items found.</Message>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Col> */}
      </div>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.error ||
            error?.data?.message ||
            "Error fetching food items"}
        </Message>
      ) : !(Array.isArray(foodItems) && foodItems.length > 0) ? (
        <div
          style={{
            ...cardStyle,
            padding: "2rem 1rem",
            margin: "1rem auto",
            maxWidth: "520px",
            textAlign: "center",
          }}
        >
          <h6 style={{ color: "#1d5f91", fontWeight: "700" }}>
            No food items yet
          </h6>
          <p className="text-muted mb-3">
            No food items have been created for this outlet yet. Create the
            first one to start selling.
          </p>
          <Button
            className={`${userInfo?.themeColor}ThemeHeaderTop`}
            style={{ fontWeight: "600", borderRadius: "8px" }}
            onClick={() => navigate("/createFoodItems")}
          >
            <FaPlus style={{ marginBottom: "2px" }} /> Create Food Item
          </Button>
        </div>
      ) : (
      <Row style={{ marginBottom: "0px", border: "0.5px solid #d7d2c3" }}>
        {searchFood?.length > 0 && (
          <h6 style={{ color: "red" }}>You are seeing searched food items</h6>
        )}
        <Col xs={12} md={2} lg={1} className="cat-panel">
          <h6 className="cat-panel-title">Categories</h6>
          <div className="cat-list">
            {getCategories().map((category) => (
              <Button
                key={category}
                style={{
                  width: "100%",
                  padding: "0.45rem 0.2rem",
                  fontSize: "0.78rem",
                  fontWeight: selectedCategory === category ? "700" : "500",
                  borderRadius: "8px",
                  border:
                    selectedCategory === category
                      ? "1px solid #057acd"
                      : "1px solid #dbe4ec",
                  color: selectedCategory === category ? "#ffffff" : "#2c3e50",
                  background:
                    selectedCategory === category
                      ? "linear-gradient(to bottom right, #057acd 0%, #1d5f91 100%)"
                      : "#ffffff",
                  boxShadow:
                    selectedCategory === category
                      ? "0 2px 6px rgba(5, 122, 205, 0.35)"
                      : "0 1px 2px rgba(0, 0, 0, 0.04)",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
                size="sm"
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </Button>
            ))}
          </div>
        </Col>
        <Col xs={12} md={4} style={{ border: "0.5px solid #d7d2c3" }}>
          {/* <h6>Categories</h6> */}

          {/* Bottom 60vh - Item Buttons */}
          <div
            style={{
              height: "70vh",
              overflowY: "auto",
              paddingTop: "0.5rem",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.1rem",
                overflow: "scroll",
              }}
            >
              {getItemsByCategory(selectedCategory)?.map((item) => {
                const quantity = itemQuantities[item.itemCode] || 0;
                return (
                  <div
                    key={item._id}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border:
                        selectedItemDetails.itemCode === item.itemCode
                          ? "3px solid orange"
                          : "0.5px solid",
                      borderRadius: "10px",
                      width: "7rem",
                      height: "9rem",
                      cursor: "pointer",
                      backgroundColor:
                        item.itemQuantity > 0 ? "inherit" : "grey",
                    }}
                    onClick={() => {
                      if (quantity === 0) {
                        setSelectedItemDetails(item);
                      }
                    }}
                  >
                    {/* Food Item Button */}
                    <LazyMemberImage
                      foodItemId={item._id}
                      imageUpdatedTimeFromDB={item.imageUploadedTime}
                      currentlySelling={item.currentlySelling}
                      photoUploaded={item.imageUploaded}
                      width="6rem"
                      height="5rem"
                    />
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize:
                          item.itemName?.length <= 15 ? "0.9rem" : "0.8rem",
                      }}
                    >
                      {makeFirstCharCapital(item.itemName)}
                      <span style={{ marginTop: "0.2rem", color: "green" }}>
                        Rs.
                        {Number(item?.availableSizes[0]?.discountPercent) > 0 ||
                        Number(item?.availableSizes[0]?.discountAmount) > 0 ? (
                          <>
                            <small style={{ textDecoration: "line-through" }}>
                              {item?.availableSizes[0]?.itemPrice?.toFixed(2)}
                            </small>
                            <small>
                              {" "}
                              {(
                                Number(item?.availableSizes[0]?.itemPrice) -
                                (Number(item?.availableSizes[0]?.itemPrice) *
                                  Number(
                                    item?.availableSizes[0]?.discountPercent
                                  )) /
                                  100 -
                                Number(item?.availableSizes[0]?.discountAmount)
                              ).toFixed(2)}
                            </small>
                          </>
                        ) : (
                          <small>
                            {item?.availableSizes[0]?.itemPrice?.toFixed(2)}
                          </small>
                        )}
                      </span>
                      <small style={{ marginTop: "0.2rem" }}>
                        Quantity : {item.itemQuantity}
                        {item.isVeg ? (
                          <CgPlayStopR
                            style={{ color: "green", width: "1rem" }}
                          />
                        ) : (
                          <CgPlayStopR
                            style={{ color: "red", width: "1rem" }}
                          />
                        )}
                      </small>{" "}
                    </span>

                    {/* Add Button or Quantity Controls */}
                  </div>
                );
              })}
            </div>
          </div>
        </Col>

        <Col
          xs={12}
          md={6}
          lg={7}
          style={{
            padding: "0.5rem",
            fontSize: "0.9rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "center",
          }}
        >
          {editable && selectedItemDetails?._id ? (
            <EditFoodItemDetails
              foodItem={selectedItemDetails}
              editStatus={handleEditStatus}
              setUpdatedFoodItem={setSelectedItemDetails}
            ></EditFoodItemDetails>
          ) : selectedItemDetails?._id ? (
            <div
              style={{
                ...cardStyle,
                width: "100%",
                marginBottom: "2rem",
                overflow: "hidden",
              }}
            >
              {/* Item header */}
              <div
                className="d-flex align-items-center flex-wrap"
                style={{
                  gap: "0.8rem",
                  padding: "0.9rem 1rem",
                  borderBottom: "1px solid #eef4f9",
                  backgroundColor: "#f8fbfe",
                }}
              >
                <LazyMemberImage
                  foodItemId={selectedItemDetails?._id}
                  imageUpdatedTimeFromDB={
                    selectedItemDetails?.imageUploadedTime
                  }
                  currentlySelling={selectedItemDetails?.currentlySelling}
                  photoUploaded={selectedItemDetails?.imageUploaded}
                  width="4.5rem"
                  height="4rem"
                />
                <div style={{ flex: "1 1 160px" }}>
                  <div
                    style={{
                      fontWeight: "700",
                      color: "#1d5f91",
                      fontSize: "1.02rem",
                    }}
                  >
                    {makeFirstCharCapital(selectedItemDetails?.itemName || "")}{" "}
                    <CgPlayStopR
                      style={{
                        color: selectedItemDetails?.isVeg ? "green" : "red",
                        width: "0.9rem",
                        marginBottom: "2px",
                      }}
                    />
                  </div>
                  <small className="text-muted">
                    {selectedItemDetails?.itemCategory}
                    {selectedItemDetails?.itemCode
                      ? ` · Code: ${selectedItemDetails.itemCode}`
                      : ""}
                    {selectedItemDetails?.localName
                      ? ` · ${selectedItemDetails.localName}`
                      : ""}
                  </small>
                </div>
                <span
                  style={{
                    padding: "0.2rem 0.7rem",
                    borderRadius: "999px",
                    fontSize: "0.75rem",
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                    backgroundColor: selectedItemDetails?.currentlySelling
                      ? "#e8f6ee"
                      : "#fdecec",
                    border: `1px solid ${
                      selectedItemDetails?.currentlySelling
                        ? "#b7e0c6"
                        : "#f5c2c7"
                    }`,
                    color: selectedItemDetails?.currentlySelling
                      ? "#1e7e34"
                      : "#c0392b",
                  }}
                >
                  {selectedItemDetails?.currentlySelling
                    ? "Selling"
                    : "Not Selling"}
                </span>
                <Button
                  size="sm"
                  className={`${userInfo?.themeColor}ThemeHeaderTop`}
                  style={{
                    fontWeight: "600",
                    borderRadius: "8px",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => setEditable(true)}
                >
                  <FaRegEdit style={{ marginBottom: "2px" }} /> Edit Food
                  Details
                </Button>
              </div>

              {/* Item facts */}
              <div style={{ padding: "0.6rem 1rem 0.9rem" }}>
                <DetailRow label="Item Code">
                  {selectedItemDetails?.itemCode ?? "-"}
                </DetailRow>
                <DetailRow label="Unique Item Code">
                  {selectedItemDetails?.uniqueItemCode || "-"}
                </DetailRow>
                <DetailRow label="Available Quantity">
                  <span
                    style={{
                      color:
                        selectedItemDetails?.itemQuantity === 0
                          ? "red"
                          : selectedItemDetails?.itemQuantity < 10
                          ? "orange"
                          : "inherit",
                    }}
                  >
                    {selectedItemDetails?.itemQuantity}
                  </span>{" "}
                  <GrEdit
                    style={{
                      cursor: "pointer",
                      color: "orange",
                      marginLeft: "0.35rem",
                      marginBottom: "2px",
                    }}
                    onClick={() => addItemHandler(selectedItemDetails)}
                  />
                </DetailRow>
                <DetailRow label="Online Order Threshold">
                  {selectedItemDetails?.onlineAvailableThreshold ?? 0}
                </DetailRow>
                <DetailRow label="GST Tax">
                  {selectedItemDetails?.gstTax ?? 0}%
                </DetailRow>
                <DetailRow label="Veg ?">
                  <YesNoChip value={selectedItemDetails?.isVeg} />
                </DetailRow>
                <DetailRow label="Currently Selling ?">
                  <YesNoChip value={selectedItemDetails?.currentlySelling} />
                </DetailRow>
                {selectedItemDetails?.itemDescription && (
                  <DetailRow label="Description">
                    {selectedItemDetails.itemDescription}
                  </DetailRow>
                )}
                <DetailRow label="Added By">
                  {selectedItemDetails?.addedBy}
                </DetailRow>

                {selectedItemDetails?.availableSizes?.length > 0 && (
                  <>
                    <div style={{ ...labelStyle, margin: "0.9rem 0 0.5rem" }}>
                      Available Sizes
                    </div>
                    {selectedItemDetails.availableSizes.map((size, index) => (
                      <div key={index} style={sizeBoxStyle}>
                        <div
                          className="d-flex justify-content-between align-items-center flex-wrap"
                          style={{ gap: "0.4rem", marginBottom: "0.25rem" }}
                        >
                          <strong
                            style={{ color: "#1d5f91", fontSize: "0.88rem" }}
                          >
                            {size.sizeName}
                            {size.sizeDescription ? (
                              <small
                                className="text-muted"
                                style={{ fontWeight: "400" }}
                              >
                                {" "}
                                · {size.sizeDescription}
                              </small>
                            ) : (
                              ""
                            )}
                          </strong>
                          <strong
                            style={{ color: "#1e7e34", fontSize: "0.9rem" }}
                          >
                            ₹ {formatAmount(size.itemPrice)}
                          </strong>
                        </div>
                        <div
                          className="d-flex flex-wrap"
                          style={{
                            gap: "0.3rem 1.1rem",
                            fontSize: "0.78rem",
                            color: "#6c757d",
                          }}
                        >
                          <span>
                            Making Cost: ₹{formatAmount(size.makingCost)}
                          </span>
                          <span>
                            Discount: {size.discountPercent ?? 0}% / ₹
                            {formatAmount(size.discountAmount)}
                          </span>
                          <span>Reduce Qty: {size.consumptionQty ?? 0}</span>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className="text-muted" style={{ padding: "1.5rem" }}>
              Select a food item to see its details
            </div>
          )}{" "}
        </Col>
      </Row>
      )}
    </>
  );
};

export default AllFoodItemsScreen;
